import type { IPersonCreate } from "../../../../interfaces/models/IPersonCreate";
import type { PersonFormFieldKey } from "./personFormTypes";

export function fieldValuesEqual(
  a: IPersonCreate[PersonFormFieldKey],
  b: IPersonCreate[PersonFormFieldKey]
): boolean {
  if (a === b) {
    return true;
  }
  if (a === undefined || b === undefined) {
    return a === b;
  }
  if (typeof a === "object" && typeof b === "object") {
    return JSON.stringify(a) === JSON.stringify(b);
  }
  return false;
}

export function computeDirtyFields(
  form: IPersonCreate,
  initial: IPersonCreate
): Partial<Record<PersonFormFieldKey, boolean>> {
  const keys = Object.keys(form) as PersonFormFieldKey[];
  const dirty: Partial<Record<PersonFormFieldKey, boolean>> = {};
  for (const key of keys) {
    if (!fieldValuesEqual(form[key], initial[key])) {
      dirty[key] = true;
    }
  }
  return dirty;
}

export function isFormDirty(dirtyFields: Partial<Record<PersonFormFieldKey, boolean>>): boolean {
  return Object.values(dirtyFields).some(Boolean);
}
